import React from 'react';
import {observer} from 'mobx-react';
import {Checkbox, Select2} from 'shared/components';
import {Table} from 'main/components';
import {FormattedMessage} from 'react-intl';
import {withState} from 'shared/core';
import ReviewsListState from 'main/containers/employees/hire/components/steps/reviews/reviews_list/ReviewsListState';
import {auth} from 'main/tools';

const ReviewsCheckbox = observer(({model, uiState}) => {
  return (
    <Checkbox
      checked={model.selected}
      onChange={() => uiState.toggleCycle(model)}
    />
  );
});

const DueDate = observer(({model}) => {
  switch (model.data.relativeDueDateUnit) {
    case 'days':
      return (
        <FormattedMessage id='employees.hire.reviews.OFFSET_DATE_IN_DAYS' values={{
          number: model.data.relativeDueDateValue
        }}
        />
      );
    case 'weeks':
      return (
        <FormattedMessage id='employees.hire.reviews.OFFSET_DATE_IN_WEEKS' values={{
          number: model.data.relativeDueDateValue
        }}
        />
      );
    default:
      throw new Error(`Relative date unit ${model.data.relativeDueDateUnit} not supported.`);
  }
});

const LaunchDate = observer(({model}) => {
  switch (model.data.relativeLaunchDateUnit) {
    case 'days':
      return (
        <FormattedMessage id='employees.hire.reviews.OFFSET_DATE_IN_DAYS' values={{
          number: model.data.relativeLaunchDateValue
        }}
        />
      );
    case 'weeks':
      return (
        <FormattedMessage id='employees.hire.reviews.OFFSET_DATE_IN_WEEKS' values={{
          number: model.data.relativeLaunchDateValue
        }}
        />
      );
    default:
      throw new Error(`Relative date unit ${model.data.relativeLaunchDateUnit} not supported.`);
  }
});

const Manager = observer(({model, uiState}) => {
  const {availableManagers} = uiState;

  return (
    <Select2
      value={model.data.reviewManagerId}
      disabled={!model.selected}
      searchable
      allowClear
      onChange={e => uiState.updateCycle(model.data, e.target.value)}
      placeholder='employees.hire.employment.Specify a manager'
    >
      {availableManagers.map((manager) =>
        <option key={manager.id} value={manager.id}>{manager.name}</option>)}
    </Select2>
  );
});

const Managers = observer(({model, uiState}) => {
  const {availableManagers} = uiState;

  return (
    <Select2
      value={model.data.reviewManagers}
      disabled={!model.selected}
      multiple
      searchable
      allowClear
      onChange={e => uiState.onManagerChange(model.data, e)}
      placeholder='employees.hire.employment.Specify a manager'
    >
      {availableManagers.map((manager) =>
        <option key={manager.id} value={manager.id}>{manager.name}</option>)}
    </Select2>
  );
});

const COLUMNS = [
  {
    component: ReviewsCheckbox,
    width: 0.5
  },
  {
    header: 'employees.hire.reviews.Reviews',
    attribute: 'data.name',
    width: 3.5
  },
  {
    header: 'employees.hire.reviews.Manager',
    component: auth.featureEnabled(':multiple_review_managers') ? Managers : Manager,
    width: 4
  },
  {
    header: 'employees.hire.reviews.Launch Date',
    component: LaunchDate,
    width: 2
  },
  {
    header: 'employees.hire.reviews.Due Date',
    component: DueDate,
    width: 2
  },
];

const ReviewsList = observer(({uiState}) => {
  return (
    <Table
      showLinks={false}
      columns={COLUMNS}
      models={uiState.viewModels}
      uiState={uiState}
    />
  );
});

export default withState(ReviewsList, ReviewsListState);
